import { Dialog, FlatButton, Checkbox, List, ListItem } from 'material-ui';
import React, { useEffect, useState } from 'react';
import { EXPORT_MAP } from './common';
import _ from 'lodash';

/**
 * 
 * @param {{ open: boolean, handleOpenExportDialog: Function, exportRows: Function }} param0 
 */
export default function ExportDialog({ open = false, handleOpenExportDialog, exportRows }) {
    const [items, setItems] = useState(EXPORT_MAP);
    const [allSelected, setAllSelected] = useState(true);

    useEffect(() => {
        if (!Object.values(items).every(i => i.value === 1)) {
            setAllSelected(false);
        }
    }, [items]);

    const handleSelectAll = () => {
        const copy = _.cloneDeep(items);
        const changeTo = allSelected ? 0 : 1;

        Object.keys(copy).forEach((key) => {
            copy[key].value = changeTo;
        });
        setItems(copy);
        setAllSelected(!allSelected);
    };

    const handleCheckboxChange = (key) => {
        setItems(prev => (
            { 
                ...prev, 
                [key]: {
                    ...prev[key],
                    value: prev[key].value === 1 ? 0 : 1,
                },
            }
        ));
    };

    const handleClose = () => {
        setItems(EXPORT_MAP);
        setAllSelected(true);
        handleOpenExportDialog();
    };

    const actions = [
        <FlatButton
            label='JSON'
            primary
            onClick={() => exportRows(
                'json', 
                Object.fromEntries(Object.keys(items).map(key => [key, items[key].value])),
            )}
        />,
        <FlatButton
            label='CSV'
            primary
            onClick={() => exportRows(
                'csv', 
                Object.fromEntries(Object.keys(items).map(key => [key, items[key].value])),
            )}
        />,
        <FlatButton
            label='Cancel'
            secondary
            onClick={handleClose}
        />,
    ];

    return (
        <Dialog
            open={open}
            actions={actions}
            key={`dialog_${open}`}
            bodyStyle={{ 
                overflowY: 'scroll',
            }}
        >
            <List>
                <ListItem>
                    <Checkbox
                        label="Select All"
                        labelStyle={{ color: '#bcbbbb' }}
                        checked={Object.values(items).every(i => i.value === 1)}
                        onCheck={handleSelectAll}
                    />
                </ListItem>
                {Object.keys(items).map(key => (
                    <ListItem key={key} innerDivStyle={{ padding: '2px 16px' }}>
                        <Checkbox
                            label={items[key].label}
                            checked={items[key].value === 1}
                            onCheck={() => handleCheckboxChange(key)}
                        />
                    </ListItem>
                ))}
            </List>
        </Dialog>
    );
}



// WEBPACK FOOTER //
// ./app/components/Hires/ExportDialog.jsx